import React from 'react'

import ProgressBar from "@ramonak/react-progress-bar";

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

//import {
//    STYLEHTML
//} from '../../../business-const/Style/Style'

import {
    COLOR
} from '../../../business-const/Color/Color'

import {
    formataValor,
    formataEstudoDiagnosticoAposentadoria,
    formataEstudoDiagnosticoAposentadoriaResumo,
} from '../../../business-components/Formata/Formata'

import {
    ano,
} from '../../../business-components/Date/Date'

import {
    round
} from '../../../business-components/round/round'

import {
    GridContainer,
    GridContainerS0,
    GridItem5,
    GridItem6,
    GridItem8,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    ChartPadrao
} from '../../../business-components/Chart/Chart'

import {
    possuiFilhao,
} from '../cadastro-form/CadastroServiceFamiliares'

import {
    ateMaisXAnos,
    relatorioModoApresentacao,
} from '../estudo-form/EstudoService'

import {
    calculaJaAposentou,
} from '../estudo-form/EstudoServiceCalculo'

import {
    CardGridEstudoPadrao,
} from '../estudo-form/EstudoComp'

import {
    existeTabelaEvolucaoValorResgate,
} from '../seguroVidaCotacao-form/SeguroVidaCotacaoServiceCotacao'

import {
    AposentadoriaExpectativaVidaCliente,
} from '../simulacaoFinanceira-form/SimulacaoFinanceiraCompParametros'

import EstudoFormCapacidadePoupancaNecessidadeAporteAposentadoria from '../estudo-form/EstudoFormCapacidadePoupancaNecessidadeAporteAposentadoria'



const DiagnosticoAposentadoriaIndependenciaFinanceiraChart = ( { values, setFieldValue, estudo,
    graficoIndependenciaFinanceiraSituacaoAtualSuperavit, graficoIndependenciaFinanceiraSituacaoAtualDeficit,
    valorRetiradaMensalMaximaConsumirReservaAposentadoria, graficoIndependenciaFinanceiraConsumirReservaAposentadoria,
    valorRetiradaMensalMaximaPreservarReservaAposentadoria, graficoIndependenciaFinanceiraPreservarReservaAposentadoria,
    valorPresenteDeficitSimulacaoMensal, graficoIndependenciaFinanceiraSituacaoIdeal,
    valorAporteMensalPreservarReservaAposentadoria, graficoIndependenciaFinanceiraViverRentabilidade,
    valorPresenteDeficitReservaInicioAposentadoria, valorDepositoUnicoManterPadraoVida, valorDepositoUnicoViverRentabilidade,
    necessidadeAposentadoria, necessidadeAposentadoriaLimiteReserva, valorDepositoViverRentabilidadeSaldoInicioAposentadoria,
    valorRetiradaMaximaPreservarRecursosFinanceirosSaldoInicioAposentadoria,
    /*valorSaldoFinalSituacaoAtual, */valorPresenteReservaInicioAposentadoria, 
    valorPresenteNecessidadesInicioAposentadoria, report, popup, simulacaoFinanceira, naoExibirCapacidadePoupanca,
    naoExibirGrafico, moreLessList, aiFT } ) => {

    const DiagnosticoAposentadoriaIndependenciaFinanceira = ( props ) => {

        const jaAposentou = calculaJaAposentou(values, ano(values.dataSimulacaoEstudo))

        const series = []

        const paletaCoresEspecifica = []


        
        if (values.exibirCapitalSeguradoCarteiraInvestimentos && existeTabelaEvolucaoValorResgate(values)) {

            const graficoIndependenciaFinanceiraSituacaoAtualCapitalSegurado = []

            estudo.current.graficoIndependenciaFinanceiraSituacaoAtual?.forEach( (linha, ind) => {

                graficoIndependenciaFinanceiraSituacaoAtualCapitalSegurado.push(
                    linha + 
                        (
                            !values.idadeSimularResgateVidaInteiraCliente ||
                            values.idadeSimularResgateVidaInteiraCliente > estudo.current.graficoIdades[ind]
                                ? 
                                    values.valorCSVidaInteiraCotacaoCliente 
                                : 
                                    0
                        ) + 
                            (
                                !values.idadeSimularResgateVidaInteiraConjuge ||
                                values.idadeSimularResgateVidaInteiraConjuge >
                                    estudo.current.graficoIdades[ind] + values.idadeDataSimulacaoConjuge -
                                        values.idadeDataSimulacaoCliente
                                    ?
                                        values.valorCSVidaInteiraCotacaoConjuge 
                                    : 
                                        0
                            )
                )
            })

            series.push(
                {
                    name: LABEL.reservaSuperavit + ' + ' + LABEL.cotacao  + ' ' + LABEL.vidaInteira,
                    type: values.utilizarVersaoSimplificadaGraficoDiagnosticoAposentadoriaIndependênciaFinanceira ? 'line' : 'area',
                    data: graficoIndependenciaFinanceiraSituacaoAtualCapitalSegurado,
                },
            )

            paletaCoresEspecifica.push(
                COLOR().corChartPadraoVidaInteiraCotacao
            )
        }



        series.push(
            {
                name: values.utilizarVersaoSimplificadaGraficoDiagnosticoAposentadoriaIndependênciaFinanceira ? LABEL.situacaoAtualManterPadraoVidaSemNovosAportes : LABEL.reservaSuperavit,
                type: values.utilizarVersaoSimplificadaGraficoDiagnosticoAposentadoriaIndependênciaFinanceira ? 'line' : 'area',
                data: graficoIndependenciaFinanceiraSituacaoAtualSuperavit,
            },
        )

        paletaCoresEspecifica.push(
            COLOR().corChartPadraoVerde
        )
        


        if (!values.utilizarVersaoSimplificadaGraficoDiagnosticoAposentadoriaIndependênciaFinanceira) {

            series.push(
                {
                    name: LABEL.reservaDeficit,
                    type: 'area',
                    data: graficoIndependenciaFinanceiraSituacaoAtualDeficit,
                },
            )

            paletaCoresEspecifica.push(
                COLOR().corChartPadraoVermelho,
            )

            if (valorRetiradaMensalMaximaConsumirReservaAposentadoria !== 0 && !aiFT) {
                series.push(
                    {
                        name: LABEL.retiradaMensalMaximaConsumirReserva.replace('$1$',
                            formataValor(valorRetiradaMensalMaximaConsumirReservaAposentadoria, 2)),
                        type: 'line',
                        data: graficoIndependenciaFinanceiraConsumirReservaAposentadoria,
                    },
                )

                paletaCoresEspecifica.push(
                    COLOR().corChartPadraoConsumirReservaSemNovosAportes,
                )
            }

            if (valorRetiradaMensalMaximaPreservarReservaAposentadoria !== 0 && !aiFT) { 
                series.push(
                    {
                        name: LABEL.retiradaMensalMaximaPreservarReserva.replace('$1$',
                            formataValor(valorRetiradaMensalMaximaPreservarReservaAposentadoria, 2)),
                        type: 'line',
                        data: graficoIndependenciaFinanceiraPreservarReservaAposentadoria,
                    },
                )

                paletaCoresEspecifica.push(
                    COLOR().corChartPadraoManterReservaSemNovosAportes,
                )
            }
        }



        if (valorPresenteDeficitSimulacaoMensal !== 0 && !aiFT) {

            series.push(
                {
                    name: LABEL.aporteMensalConsumirReserva.replace('$1$',
                        formataValor(valorPresenteDeficitSimulacaoMensal, 2)),
                    type: 'line',
                    data: graficoIndependenciaFinanceiraSituacaoIdeal,
                },
            )
        
            paletaCoresEspecifica.push(
                COLOR().corChartPadraoConsumirReservaManterPadraoVida,
            )
        }

        if (valorAporteMensalPreservarReservaAposentadoria !== 0 && !aiFT) {

            series.push(
                {
                    name: LABEL.aporteMensalPreservarReserva.replace('$1$',
                        formataValor(valorAporteMensalPreservarReservaAposentadoria, 2)),
                    type: 'line',
                    data: graficoIndependenciaFinanceiraViverRentabilidade,
                },
            )
        
            paletaCoresEspecifica.push(
                COLOR().corChartPadraoManterReservaManterPadraoVida,
            )
        }

        const categories = estudo.current.graficoIdadesGraficos

        const GridTabelas = report ? GridItem12 : GridItem11

        const GridGrafico =
            simulacaoFinanceira
                ? 
                    report && !popup ? GridItem12 : GridItem11
                :
                    report ? GridItem12 : GridItem11

        const reportDiagnostico = popup || values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioPaisagem ? false : report

        const GridItemGrafico = aiFT ? GridItem11 : GridItem12

        const GridItemGrauIndependenciaFinanceira = report ? GridItem12 : GridItem8

        const completed =
            valorPresenteNecessidadesInicioAposentadoria > 0
                ?
                    round(valorPresenteReservaInicioAposentadoria / valorPresenteNecessidadesInicioAposentadoria * 100, 2)
                :
                    0

        return (
            <div
                {...props}
            >
                <GridContainer>
                    <GridItemGrafico>
                        <GridContainerS0>
                            {!simulacaoFinanceira && !naoExibirCapacidadePoupanca && !aiFT && (
                                <GridTabelas>
                                    <EstudoFormCapacidadePoupancaNecessidadeAporteAposentadoria
                                        values={values}
                                        estudo={estudo}
                                        report={report}
                                    />
                                </GridTabelas>
                            )}

                            {!naoExibirGrafico && (
                                <GridGrafico
                                    className={simulacaoFinanceira ? 'mt--7' : (report ? 'mt--5' : 'mt--15' /* mudança da fonte: 'mt--0' */)}
                                >
                                    <div
                                        className={aiFT ? '' : 'ml-5'}
                                    >
                                        <ChartPadrao
                                            titleText={''} // mudança da fonte: titleText={popup ? '' : LABEL.diagnosticoAposentadoriaIndependenciaFinanceira}
                                            type={values.utilizarVersaoSimplificadaGraficoDiagnosticoAposentadoriaIndependênciaFinanceira ? 'line' : 'area'}
                                            series={series}
                                            height={
                                                simulacaoFinanceira
                                                    ?
                                                        popup ? 480 : 350 
                                                    :
                                                        report ? aiFT ? 200 : 300 : aiFT ? 320 : 500
                                            }
                                            //legendHorizontalAlign={'left'}
                                            stacked={false}
                                            categories={categories}
                                            categories2={estudo.current.graficoAnos}
                                            paletaCores={paletaCoresEspecifica}
                                            //notLegendShow={true}
                                            dataLabelsEnabled={values.modoApresentacao || popup}
                                            dataLabelsEnabledReport={values.formatoReport === HARDCODE.idFormatoReportImpressao}
                                            dataLabelsType='Idade'
                                            dataLabelsInterval={-1}
                                            dataLabelsDestaque={[values.idadeVaiAposentarCliente]}
                                            notInverseOrder={false}
                                            //legendFixedEnabled={true}
                                            toolTipX={true}
                                            toolTipXTotal={false}
                                            report={!aiFT && reportDiagnostico/*true*//*report*/}
                                            formatoReport={values.formatoReport}
                                            fillOpacity={0.6}//0.8
                                            //fillType='gradient'
                                            notLegendShow={aiFT}
                                            aiFT={aiFT}
                                        />
                                    </div>
                                    
                                    {/*valorPresenteNecessidadesInicioAposentadoria !== 0*/completed !== 0 && !aiFT && (
                                        <GridContainerS0
                                            className='justify-center'
                                        >
                                            <GridItemGrauIndependenciaFinanceira
                                                className={'ml-5' + (report && !simulacaoFinanceira ? ' mt-3 mb--2' : ' mt-3 mb-2')}
                                                // className={'ml-5' + (report ? ' mt-2' : ' mt-10')} // antes de mover ProgressBar para cima
                                            >
                                                <GridContainerS0>
                                                    <GridItem5
                                                        className={'font-medium' + (report && !popup ? ' text-11' : ' text-13')}
                                                        align='right'
                                                    >
                                                        <div
                                                            className={(report && !popup ? 'mt-1 ' : '') + 'mr-2'}
                                                        >
                                                            {LABEL.grauIndependenciaFinanceira.replace('$1$', values.idadeFinalVitalicioClienteConjuge)}
                                                        </div>
                                                    </GridItem5>

                                                    <GridItem6
                                                        align='left'
                                                    >
                                                        <ProgressBar
                                                            completed={completed}
                                                            labelColor={COLOR().corDestaquePreto}
                                                            bgColor={
                                                                completed >= HARDCODE.grauIndependenciaFinanceiraMinimo
                                                                    ?
                                                                        completed >= HARDCODE.grauIndependenciaFinanceiraIdeal
                                                                            ?
                                                                                COLOR().corChartPadraoVerde
                                                                            :
                                                                                COLOR().corChartPadraoAmarelo
                                                                    :
                                                                        COLOR().corChartPadraoVermelho}
                                                            labelAlignment='outside'
                                                        />
                                                    </GridItem6>
                                                </GridContainerS0>
                                            </GridItemGrauIndependenciaFinanceira>
                                        </GridContainerS0>
                                    )}

                                    <GridContainerS0
                                        align='left'
                                    >
                                        {(simulacaoFinanceira ||
                                        (!values.naoExibirAcumulacaoAposentadoriaProjetoVidaSonho)) && !aiFT
                                            ?
                                                <>
                                                    {valorPresenteDeficitReservaInicioAposentadoria > 0 &&
                                                    valorDepositoUnicoManterPadraoVida && jaAposentou
                                                        ?
                                                            <GridItem12
                                                                className='mt-5 ml-5'
                                                            >
                                                                {formataEstudoDiagnosticoAposentadoria(
                                                                    MESSAGE().diagnosticoAposentadoriaDepositoUnicoManterPadraoVida,
                                                                        valorDepositoUnicoManterPadraoVida)}
                                                            </GridItem12>
                                                        :
                                                            ''
                                                    }

                                                    {/*valorPresenteDeficitReservaInicioAposentadoria > 0 &&*/valorDepositoUnicoViverRentabilidade && jaAposentou
                                                        ?
                                                            <GridItem12
                                                                className='mt-5 ml-5'
                                                            >
                                                                {formataEstudoDiagnosticoAposentadoria(
                                                                    MESSAGE().diagnosticoAposentadoriaDepositoUnicoViverRentabilidade,
                                                                        valorDepositoUnicoViverRentabilidade)}
                                                            </GridItem12>
                                                        :
                                                            ''
                                                    }

                                                    {!jaAposentou && (
                                                        <>
                                                            {valorAporteMensalPreservarReservaAposentadoria > 0 && (
                                                                <GridItem12
                                                                    className='mt-5 ml-5'
                                                                >
                                                                    {
                                                                        formataEstudoDiagnosticoAposentadoriaResumo(
                                                                           (valorPresenteDeficitSimulacaoMensal ? MESSAGE(values, reportDiagnostico).diagnosticoAposentadoriaIndependenciaFinanceiraComNovosAportes : MESSAGE(values, reportDiagnostico).diagnosticoAposentadoriaIndependenciaFinanceiraComNovosAportesSemValorPresenteDeficitSimulacaoMensal)
                                                                                .replace(HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraPadraoVida,
                                                                                    necessidadeAposentadoria)
                                                                                .replace(HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraAporteMensalPreservarReserva,
                                                                                    formataValor(valorAporteMensalPreservarReservaAposentadoria, 2))
                                                                                .replace(HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraComNovosAportesAporteUnico,
                                                                                    values.naoExibirOpcaoAporteUnico
                                                                                        ?
                                                                                            ''
                                                                                        :
                                                                                            (MESSAGE(values, reportDiagnostico).diagnosticoAposentadoriaIndependenciaFinanceiraComNovosAportesAporteUnico
                                                                                                .replace(HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraAporteUnico,
                                                                                                    formataValor(valorDepositoUnicoViverRentabilidade, 2))))
                                                                                .replace(HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraRecursosFinanceirosPreservarReserva,
                                                                                    formataValor(valorDepositoViverRentabilidadeSaldoInicioAposentadoria, 2))
                                                                                .replace('$rendaVitaliciaFilhao$', possuiFilhao(values) ? MESSAGE().rendaVitaliciaFilhao : '')
                                                                                .replace(HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraAporteMensalConsumirReserva,
                                                                                    formataValor(valorPresenteDeficitSimulacaoMensal, 2))
                                                                                .replace(HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraComNovosAportesAporteUnico,
                                                                                    values.naoExibirOpcaoAporteUnico
                                                                                        ?
                                                                                            ''
                                                                                        :
                                                                                            (MESSAGE(values, reportDiagnostico).diagnosticoAposentadoriaIndependenciaFinanceiraComNovosAportesAporteUnico
                                                                                                .replace(HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraAporteUnico,
                                                                                                    formataValor(valorDepositoUnicoManterPadraoVida, 2))))
                                                                            
                                                                                .replace(HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraAnos,
                                                                                    values.idadeFinalVitalicioClienteConjuge), reportDiagnostico
                                                                        )
                                                                    }
                                                                </GridItem12>
                                                            )}

                                                        
                                                        </>
                                                    )}

                                                    {valorRetiradaMensalMaximaPreservarReservaAposentadoria > 0 && (
                                                        <GridItem12
                                                            className='mt-5 ml-5'
                                                        >
                                                            {
                                                                formataEstudoDiagnosticoAposentadoriaResumo(
                                                                    (necessidadeAposentadoriaLimiteReserva ? MESSAGE(values, reportDiagnostico).diagnosticoAposentadoriaIndependenciaFinanceiraSemNovosAportes : MESSAGE(values, reportDiagnostico).diagnosticoAposentadoriaIndependenciaFinanceiraSemNovosAportesSemNecessidadeAposentadoriaLimiteReserva)
                                                                        .replace(HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraPreservarReservaSemAporte,
                                                                            formataValor(valorRetiradaMensalMaximaPreservarReservaAposentadoria, 2))
                                                                        .replace(HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraRecursosFinanceirosPreservarReservaSemAporte,
                                                                            formataValor(valorRetiradaMaximaPreservarRecursosFinanceirosSaldoInicioAposentadoria, 2))
                                                                        .replace('$rendaVitaliciaFilhao$', possuiFilhao(values) ? MESSAGE().rendaVitaliciaFilhao : '')
                                                                        .replace(HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraConsumirReservaSemAporte ,
                                                                            formataValor(valorRetiradaMensalMaximaConsumirReservaAposentadoria, 2))
                                                                        .replace(HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraAnos,
                                                                            values.idadeFinalVitalicioClienteConjuge)
                                                                        //.replace(HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraCorSituacaoAtualSuperavitDeficit,
                                                                        //    values.naoExibirOpcaoAporteUnico
                                                                        //        ?
                                                                        //            STYLEHTML().styleHtmlDiagnosticoAposentadoriaIndependenciaFinanceiraCorSituacaoAtualSuperavit
                                                                        //        :
                                                                        //            valorSaldoFinalSituacaoAtual > 0
                                                                        //                ?
                                                                        //                    STYLEHTML().styleHtmlDiagnosticoAposentadoriaIndependenciaFinanceiraCorSituacaoAtualSuperavit
                                                                        //                :
                                                                        //                    STYLEHTML().styleHtmlDiagnosticoAposentadoriaIndependenciaFinanceiraCorSituacaoAtualDeficit)
                                                                        //.replace(HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraRecursosFinanceirosExpectativaVida,
                                                                        //    formataValor(valorSaldoFinalSituacaoAtual, 2))
                                                                        .replace(HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraPadraoVida,
                                                                            necessidadeAposentadoriaLimiteReserva)
                                                                        .replace(HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraAnos,
                                                                            simulacaoFinanceira
                                                                                ?
                                                                                    ateMaisXAnos(values.idadeLimiteReservaAposentadoria, values.idadeExpectativaVidaCliente)
                                                                                :
                                                                                    ateMaisXAnos(values.recursosFinanceirosAcumuladosAposentadoriaIdadeAte, values.idadeExpectativaVidaCliente)
                                                                            ), reportDiagnostico
                                                                )
                                                            }
                                                        </GridItem12>
                                                    )}

                                                    {/*valorPresenteDeficitReservaInicioAposentadoria > 0 && 
                                                    (valorDepositoUnicoManterPadraoVida || valorDepositoUnicoViverRentabilidade)
                                                        ?
                                                            <br />
                                                        :
                                                            ''
                                                    */}
                                                </>
                                            :
                                                ''
                                        }
                                    </GridContainerS0>
                                    
                                    {(!report || popup)  && values.tabClienteFormList !== LABEL.tabClienteFormListRelatorio && values.modoApresentacao && (
                                        <GridContainerS0
                                            className='justify-center mt-10'
                                        >
                                            <GridItem6>
                                                <AposentadoriaExpectativaVidaCliente
                                                    values={values}
                                                    setFieldValue={setFieldValue}
                                                />
                                            </GridItem6>
                                        </GridContainerS0>
                                    )}
                                </GridGrafico>
                            )}
                        </GridContainerS0>
                    </GridItemGrafico>
                </GridContainer>
            </div>       
        )
    }

    return (
        <GridItem12>
            {report || relatorioModoApresentacao(values)
                ?
                    <DiagnosticoAposentadoriaIndependenciaFinanceira
                        className={simulacaoFinanceira ? 'mt-10' : aiFT ? 'mt-14' : ''/*'mt-3 ml-3'*/}
                    />
                :
                    <CardGridEstudoPadrao
                        label={
                            !relatorioModoApresentacao(values)
                                ?
                                    LABEL.diagnosticoAposentadoriaIndependenciaFinanceira
                                :
                                    HARDCODE.modoApresentacaoRelatorio
                        }
                        component={
                            <div
                                className='ml-3'
                            >
                                <DiagnosticoAposentadoriaIndependenciaFinanceira/>
                            </div>
                        }
                        overflowX={false}
                        modoApresentacao={values.modoApresentacao}
                        nameListaMoreLess={moreLessList}
                        listaMoreLess={moreLessList ? values[moreLessList] : ''}
                        idListaMoreLess={HARDCODE.diagnosticoAposentadoriaIndependenciaFinanceiraEstudoChart}
                        setFieldValue={setFieldValue}
                    />
            }
        </GridItem12>
    )
}

export default DiagnosticoAposentadoriaIndependenciaFinanceiraChart